<div class="input-group my-3 px-3">
  <input
    #search
    type="text"
    class="form-control border-right-0 m-0 focus"
    size="45"
    width="100px"
    name="search"
    autocomplete="off"
    i18n-placeholder="@@app.search_for_reference_e_number"
    placeholder="Search for Reference, Enumber, Description"
    spellcheck="false"
    (input)="onSearch(search.value)"
    (paste)="onSearch(search.value)">
    <div class="input-group-append">
      <div class="input-group-text bg-white px-1">
        @if (search.value) {
          <div class="mb-0 mr-2 cursor-pointer" (click)="clearInputField($event)" #clear>
            <mark class="searchOptionsFontSize font-size-12 bg-white" i18n="@@app.ClearSample">Clear</mark>
          </div>
        }
        @if (!search.value) {
          <i class="iconSize se-icon cursor-pointer">action_search_stroke</i>
        } @else {
          <i class="iconSize se-icon cursor-pointer" (click)="onCloseClick($event)">action_delete_cross</i>
        }
      </div>
    </div>
  </div>
